import api from '@/plugins/axios';
import { mountUrl } from './helper';

const BASE_PATH = 'service_order';

export default {
  async create(serviceOrderId, data, entity) {
    const url = mountUrl(`/${BASE_PATH}/${serviceOrderId}/${entity}/audio/create`);
    return api.post(url, data);
  },
  async update(serviceOrderId, audioId, data) {
    const url = mountUrl(`/${BASE_PATH}/${serviceOrderId}/audio/${audioId}`);
    return api.patch(url, data);
  },
  async inactivate(serviceOrderId, audioId) {
    const url = mountUrl(`/${BASE_PATH}/${serviceOrderId}/audio/${audioId}/disable`);
    return api.delete(url);
  }
};
